document.addEventListener("DOMContentLoaded", function () {
  var lazyloadImages = document.querySelectorAll("img.lazyload");

  // Adjust the threshold for mobile devices
  var thresholdValue = window.innerWidth <= 767 ? 0.5 : 0.2;

  var options = {
    root: null,
    rootMargin: "0px",
    threshold: thresholdValue,
  };

  var observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var img = entry.target;
        img.setAttribute("src", img.getAttribute("data-src"));
        img.removeAttribute("data-src");
        img.onload = function () {
          img.classList.add("lazyloaded");
        };

        observer.unobserve(img);
      }
    });
  }, options);

  lazyloadImages.forEach(function (img) {
    observer.observe(img);
  });
});
